import { DialogContent, DialogActions } from '@mui/material';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { icons } from '@shared/static/icons';
import { useGroups } from '@app/api/groups/useGroups';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CounterTag } from '@shared/ui/parts';
import { getTotalCards } from '@utils/helpers';
import { setCardsParamsNoFetch, resetAll } from '@app/store/slices/cardsSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function FreezeTeamDialog({ close, data }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { freezeGroup } = useGroups();

  async function onSubmit() {
    setIsLoading(true);
    try {
      await freezeGroup({ group_id: data.id });
      close();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <DialogContent>
        <div className="form">
          <p>{t('are_you_sure_freeze_team')}</p>
          <CounterTag data={data} iconType="members" />
        </div>
        <Note
          marginTop
          type="warning"
          title={t('important')}
          content={t('team_freeze_note')}
        >
          {getTotalCards(data) > 0 && (
            <button
              className="dashed-btn"
              onClick={() => {
                dispatch(resetAll());
                dispatch(setCardsParamsNoFetch({ page: 1, group_id: data.id }));
                navigate('/cards');
                close();
              }}
            >
              <span>
                {t('go_to_team_cards')} ({getTotalCards(data)}){' '}
              </span>
              {icons['arrow-right']}
            </button>
          )}
        </Note>
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="freeze"
            onClick={onSubmit}
            loading={isLoading}
          >
            {t('yes_freeze')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
